import type { TtsProfile } from '@core/tts/ttsProfile'

export interface TtsPlaybackOptions {
  /** When speed was baked into the API-generated audio, use 1 to avoid double-application */
  playbackRate?: number;
}

export function applyTtsPlaybackSettings(
  audio: HTMLAudioElement,
  profile: TtsProfile,
  options?: TtsPlaybackOptions
): void {
  const effectiveRate = options?.playbackRate ?? profile.playbackRate;
  audio.playbackRate = effectiveRate
  if ('preservesPitch' in audio) audio.preservesPitch = false
  if ('mozPreservesPitch' in audio) audio.mozPreservesPitch = false
  if ('webkitPreservesPitch' in audio) audio.webkitPreservesPitch = false
}
